var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFamily(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1301.94 730.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .b1ba5eb5-475a-440c-afbd-61b355da7e64, .f10bb296-219d-400e-895b-95368c902bfe {\n        fill: #f4beb2;\n      }\n\n      .a11db4fb-67b7-4bde-be06-572dc03d7024, .a45bfe8b-37e4-4388-b7c3-2a0f6269eabe, .a54fbd87-bec4-411d-87ab-5a8e2b316ee1, .aa3c9cd1-9f7a-4e7d-a371-0f23f1588309, .af0f1cc0-2f96-42f4-982b-636ce73b5e90, .b50457b7-92c8-4231-ad12-d1c6f262f462, .bbe4f893-329d-46d5-a076-961d9f041937, .e4114198-ea66-45af-a16d-0729c7b506a8, .f0146d0d-9ae6-4606-9c0b-f52335d9290f, .f10bb296-219d-400e-895b-95368c902bfe, .f9ae9547-d4e3-46ba-a3b2-f7f377aeef97, .fadfdf82-06e2-42f7-9290-8e74cda83a61 {\n        stroke: #000;\n        stroke-linejoin: round;\n      }\n\n      .a11db4fb-67b7-4bde-be06-572dc03d7024, .a45bfe8b-37e4-4388-b7c3-2a0f6269eabe, .a54fbd87-bec4-411d-87ab-5a8e2b316ee1, .af0f1cc0-2f96-42f4-982b-636ce73b5e90, .b50457b7-92c8-4231-ad12-d1c6f262f462, .bbe4f893-329d-46d5-a076-961d9f041937, .e4114198-ea66-45af-a16d-0729c7b506a8, .f0146d0d-9ae6-4606-9c0b-f52335d9290f, .f10bb296-219d-400e-895b-95368c902bfe, .f9ae9547-d4e3-46ba-a3b2-f7f377aeef97, .fadfdf82-06e2-42f7-9290-8e74cda83a61 {\n        stroke-linecap: round;\n      }\n\n      .a54fbd87-bec4-411d-87ab-5a8e2b316ee1, .f10bb296-219d-400e-895b-95368c902bfe {\n        stroke-width: 7.5px;\n      }\n\n      .a11db4fb-67b7-4bde-be06-572dc03d7024, .a45bfe8b-37e4-4388-b7c3-2a0f6269eabe, .a54fbd87-bec4-411d-87ab-5a8e2b316ee1, .aa3c9cd1-9f7a-4e7d-a371-0f23f1588309, .af0f1cc0-2f96-42f4-982b-636ce73b5e90, .bbe4f893-329d-46d5-a076-961d9f041937, .f0146d0d-9ae6-4606-9c0b-f52335d9290f, .f54e60f4-bdef-4140-af75-74e178217e8b, .f9ae9547-d4e3-46ba-a3b2-f7f377aeef97, .fadfdf82-06e2-42f7-9290-8e74cda83a61 {\n        fill: none;\n      }\n\n      .f0146d0d-9ae6-4606-9c0b-f52335d9290f {\n        stroke-width: 7px;\n      }\n\n      .bc0b5feb-563d-4fb7-a60b-0f01c78141f8 {\n        fill: #231f20;\n      }\n\n      .a45bfe8b-37e4-4388-b7c3-2a0f6269eabe {\n        stroke-width: 8.17px;\n      }\n\n      .b50457b7-92c8-4231-ad12-d1c6f262f462, .bbe4f893-329d-46d5-a076-961d9f041937 {\n        stroke-width: 10.2px;\n      }\n\n      .b50457b7-92c8-4231-ad12-d1c6f262f462 {\n        fill: #ee6e51;\n      }\n\n      .a11db4fb-67b7-4bde-be06-572dc03d7024, .aa3c9cd1-9f7a-4e7d-a371-0f23f1588309 {\n        stroke-width: 16.33px;\n      }\n\n      .f9ae9547-d4e3-46ba-a3b2-f7f377aeef97 {\n        stroke-width: 9.8px;\n      }\n\n      .e4114198-ea66-45af-a16d-0729c7b506a8 {\n        fill: #92d4cd;\n      }\n\n      .e4114198-ea66-45af-a16d-0729c7b506a8, .fadfdf82-06e2-42f7-9290-8e74cda83a61 {\n        stroke-width: 8.36px;\n      }\n\n      .af0f1cc0-2f96-42f4-982b-636ce73b5e90 {\n        stroke-width: 6.24px;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "family") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edc7edba-0206-4e1f-9e2a-be9b14914397",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ba2507c1-d200-4f41-bec4-415395def611",
    "data-name": "colour"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f10bb296-219d-400e-895b-95368c902bfe",
    d: "M774.73,247a183.83,183.83,0,0,1,33.35-105.87L782.6,37.81c-6.58-16.4-31-14.49-41.6,3.25L677.69,147.44c-5.44,9.13-15.53,14.93-25.17,14.47l-31.47-1.52a162.72,162.72,0,0,1,19.52,74c1.16,60.23-30.61,113.68-79.81,146l-29,65.89c-8.17,18.58,7.11,34.46,26,27l43.06-17A148.86,148.86,0,0,1,610.77,400c1.12-2.5,2.37-5,3.72-7.48a120.79,120.79,0,0,1,15-21.48q2.14-2.46,4.43-4.8c12.37-13.12,28.9-22.47,45.45-28.61,2.1-.7,4.23-1.33,6.36-1.91A128.64,128.64,0,0,1,705,332.08q3.35-.33,6.7-.53a195.63,195.63,0,0,1,33.39,1.05c2.82.55,5.61,1.26,8.37,2.07,2.47.73,4.92,1.54,7.33,2.43s4.78,1.84,7.11,2.87a114.75,114.75,0,0,1,33.73,22.55c1.65,1.58,3.26,3.2,4.83,4.88,14.41,16.6,26.63,36,30.4,58.25.52,2.56.95,5.16,1.3,7.78a120.81,120.81,0,0,1,1.07,16,119.22,119.22,0,0,1-9,45.52l0,.05c11.92-2.67,22.86-14.11,22.72-27.38l-.7-70.22A184.45,184.45,0,0,1,774.73,247Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f0146d0d-9ae6-4606-9c0b-f52335d9290f",
    d: "M858.58,105.74S837.2,18.29,919.37,5.1c0,0-24.57,54.83,14.17,87.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f0146d0d-9ae6-4606-9c0b-f52335d9290f",
    d: "M965.74,88.24S930,61.47,941.17,39.8c0,0-23.43,2.25-25.48,21.49C914,77.22,933.52,90.81,933.54,92.55"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "bc0b5feb-563d-4fb7-a60b-0f01c78141f8",
    cx: 450.52,
    cy: 279.6,
    r: 12.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "bc0b5feb-563d-4fb7-a60b-0f01c78141f8",
    cx: 991.78,
    cy: 238.84,
    r: 12.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "bc0b5feb-563d-4fb7-a60b-0f01c78141f8",
    cx: 595.78,
    cy: 238.84,
    r: 12.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "bc0b5feb-563d-4fb7-a60b-0f01c78141f8",
    cx: 827.09,
    cy: 241.66,
    r: 12.14
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bc0b5feb-563d-4fb7-a60b-0f01c78141f8",
    cx: 719.6,
    cy: 300.76,
    rx: 13.19,
    ry: 11.09,
    transform: "translate(31.39 667.69) rotate(-50.75)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bc0b5feb-563d-4fb7-a60b-0f01c78141f8",
    cx: 1022.29,
    cy: 467.8,
    rx: 13.19,
    ry: 11.09,
    transform: "translate(-52.83 139.12) rotate(-7.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a45bfe8b-37e4-4388-b7c3-2a0f6269eabe",
    d: "M836.86,425.65c10.79-1.06,6.56,13.61,28.55,1.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a45bfe8b-37e4-4388-b7c3-2a0f6269eabe",
    d: "M720,309s7.5,7.6,16.27,22.83"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bc0b5feb-563d-4fb7-a60b-0f01c78141f8",
    cx: 707.66,
    cy: 300.76,
    rx: 11.09,
    ry: 13.19,
    transform: "translate(123.45 800.69) rotate(-63.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bc0b5feb-563d-4fb7-a60b-0f01c78141f8",
    cx: 247.64,
    cy: 377.4,
    rx: 11.09,
    ry: 13.19,
    transform: "translate(-200.54 431.25) rotate(-63.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a45bfe8b-37e4-4388-b7c3-2a0f6269eabe",
    d: "M599.17,447c-22.72,15.65-47.95,24-74.38,17.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a45bfe8b-37e4-4388-b7c3-2a0f6269eabe",
    d: "M702.73,310.69s-3.67,8.08-10.37,20.57"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bc0b5feb-563d-4fb7-a60b-0f01c78141f8",
    cx: 938.88,
    cy: 479.12,
    rx: 5.44,
    ry: 4.57,
    transform: "translate(-61.65 810.76) rotate(-45.37)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bc0b5feb-563d-4fb7-a60b-0f01c78141f8",
    cx: 938.88,
    cy: 474.09,
    rx: 4.57,
    ry: 5.44,
    transform: "translate(217.13 1239.16) rotate(-73.46)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "bc0b5feb-563d-4fb7-a60b-0f01c78141f8",
    cx: 977.36,
    cy: 393.22,
    r: 4.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "bc0b5feb-563d-4fb7-a60b-0f01c78141f8",
    cx: 928.58,
    cy: 412.05,
    r: 4.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M977.53,319.29a62.84,62.84,0,0,1,21.72,15c1.18,1.22,2.3,2.49,3.38,3.8s2.42,2.69,3.56,4.11a61.71,61.71,0,0,1,10.89,56.47,40.4,40.4,0,0,1-7.46,13.58c-2.91,3.57-6.09,9.36-2.33,14.73.39.56.69,1,1.27,1.94l3.79,6.8c9.7,18.91,23.77,59.37-21.67,62.06C969.61,499,964.75,473,964.1,458.24a50.09,50.09,0,0,0-1.38-9.68h0a10.18,10.18,0,0,0-4.84-6.49l-.4-.22a13.19,13.19,0,0,0-6.08-1.54q-2.86,0-5.7-.12a30.32,30.32,0,0,1-9.5-1.92l-.05,0a61.56,61.56,0,0,1-39-49.46,62.92,62.92,0,0,1-.53-8.62c0-1.42.07-2.83.15-4.25.78-17.16,5.3-35.57,19.54-46.24"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    cx: 944.31,
    cy: 309.89,
    r: 7.76
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "b50457b7-92c8-4231-ad12-d1c6f262f462",
    d: "M911,304.35a4.25,4.25,0,0,1,5.77-3.62l19.92,7.69a7.74,7.74,0,0,1,13-4.1l15.95-15a3.68,3.68,0,0,1,5.93,1.29c6.1,14.89,6.51,24.51,5.83,29.87a4.24,4.24,0,0,1-5.91,3.37l-21.06-9.2a7.73,7.73,0,0,1-8.92,2.47L924.1,335a3.68,3.68,0,0,1-6-1C911.39,319.33,910.56,309.73,911,304.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b50457b7-92c8-4231-ad12-d1c6f262f462",
    d: "M946.51,302.31c-3-7.17-7.37-14-15.26-17.52a78.07,78.07,0,0,1,7.57,19.62"
  })), /*#__PURE__*/React.createElement("path", {
    className: "f54e60f4-bdef-4140-af75-74e178217e8b",
    d: "M959.44,62.28a184.72,184.72,0,0,0-98.33,341.09h0s12.22,9.21,6.29,35.91C861.47,472.66,818.45,567.6,906.71,598c68.72,23.67,74.94-55.62,75.73-101.34-14.15-5.05-17.79-25.86-18.34-38.43a50.09,50.09,0,0,0-1.38-9.68,10.18,10.18,0,0,0-4.84-6.49l-.4-.22a13.19,13.19,0,0,0-6.08-1.54q-2.86,0-5.7-.12a30.32,30.32,0,0,1-9.5-1.92l-.05,0a61.56,61.56,0,0,1-39-49.46,62.92,62.92,0,0,1-.53-8.62c0-1.42.07-2.83.15-4.25.78-17.16,5.3-35.57,19.54-46.24h0c-5-12.23-5.67-20.49-5.28-25.33a4.25,4.25,0,0,1,5.77-3.62l19.92,7.7a7.89,7.89,0,0,1,2.14-4h0a78.07,78.07,0,0,0-7.57-19.62c7.89,3.49,12.21,10.35,15.26,17.52l-.3.08a7.65,7.65,0,0,1,3.48,1.93l15.95-15a3.68,3.68,0,0,1,5.93,1.29c5.67,13.85,6.42,23.13,5.95,28.68h0a62.84,62.84,0,0,1,21.72,15c1.18,1.22,2.3,2.49,3.38,3.8s2.42,2.69,3.56,4.11a61.71,61.71,0,0,1,10.89,56.47,40.4,40.4,0,0,1-7.46,13.58c-2.66,3.28-5.54,8.41-3.11,13.38A184.75,184.75,0,0,0,1144.14,247C1144.14,145,1061.45,62.28,959.44,62.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a45bfe8b-37e4-4388-b7c3-2a0f6269eabe",
    d: "M995.86,497.82s4.08,16.58-5.76,39.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a45bfe8b-37e4-4388-b7c3-2a0f6269eabe",
    d: "M1011.09,493s4.08,16.58-5.76,39.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a45bfe8b-37e4-4388-b7c3-2a0f6269eabe",
    d: "M998.44,439.26s-2.17,25.38-58,34.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a45bfe8b-37e4-4388-b7c3-2a0f6269eabe",
    d: "M962.76,450.16S959.43,465.38,939.2,478"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bc0b5feb-563d-4fb7-a60b-0f01c78141f8",
    cx: 808.27,
    cy: 605.86,
    rx: 6.72,
    ry: 7.99,
    transform: "translate(-199.21 679) rotate(-41.01)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bc0b5feb-563d-4fb7-a60b-0f01c78141f8",
    cx: 627.22,
    cy: 558.44,
    rx: 6.72,
    ry: 7.99,
    transform: "translate(-212.52 548.56) rotate(-41.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M662.94,554.82a119.84,119.84,0,0,1-60.2-79.65c-.58-2.66-1.07-5.36-1.42-8.14a151.2,151.2,0,0,1,9.45-67c1.12-2.5,2.37-5,3.72-7.48a120.79,120.79,0,0,1,15-21.48q2.14-2.46,4.43-4.8c12.37-13.12,28.9-22.47,45.45-28.61,2.1-.7,4.23-1.33,6.36-1.91A128.64,128.64,0,0,1,705,332.08q3.35-.33,6.7-.53a195.63,195.63,0,0,1,33.39,1.05c2.82.55,5.61,1.26,8.37,2.07,2.47.73,4.92,1.54,7.33,2.43s4.78,1.84,7.11,2.87a114.75,114.75,0,0,1,33.73,22.55c1.65,1.58,3.26,3.2,4.83,4.88,14.41,16.6,26.63,36,30.4,58.25.52,2.56.95,5.16,1.3,7.78a120.81,120.81,0,0,1,1.07,16,119.22,119.22,0,0,1-9,45.52c-1,2.34-2,4.64-3.1,6.9C814.41,523.42,796.44,541.39,776,555c-2.21,1.19-4.47,2.3-6.76,3.35h0c-6,3.15-9.32,12.34-8.79,15.33,1.2,6.79-2,29.62-3.84,36.27-19.4,69.29-61,61.86-77.86,61.23-22.53-.83-40.37-18.28-40.82-40.82-.59-29.65,20-54.06,30.38-61.24C675.15,564.34,668.37,558.36,662.94,554.82Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a11db4fb-67b7-4bde-be06-572dc03d7024",
    cx: 766.95,
    cy: 650.01,
    rx: 43.79,
    ry: 71.92
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bc0b5feb-563d-4fb7-a60b-0f01c78141f8",
    cx: 766.95,
    cy: 650.01,
    rx: 13.02,
    ry: 21.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa3c9cd1-9f7a-4e7d-a371-0f23f1588309",
    d: "M672.61,670.48c-7.53,21.76-21.77,36.44-38.1,36.44-24.19,0-43.79-32.2-43.79-71.92s19.6-71.92,43.79-71.92c10.09,0,18.1,4,25.51,13.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bc0b5feb-563d-4fb7-a60b-0f01c78141f8",
    d: "M639.45,615.21a8.75,8.75,0,0,0-4.94-1.6c-7.19,0-13,9.58-13,21.39s5.83,21.39,13,21.39c3.51,0,6.69-2.29,9-6A41.38,41.38,0,0,1,638,630.31,65.09,65.09,0,0,1,639.45,615.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M662.63,650S597.84,665.67,538,605.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M709.84,648.16S645,663.82,585.23,604"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M761.66,567.72s105.58-49.85,43.07,45.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M671,565.91s-75.28-53.44-41.1-2.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M671,505.46c0,30.38,52.18,30.38,52.18,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M627.22,451.34q21.87-14.23,43.76-5.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M763.36,451.34q-21.89-14.23-43.76-5.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M1006.51,425.62s139.67,6.95,15.78,44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M500.88,101.06s38.73,61.81-6.82,89.45-50.64-16.74-50.64-16.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M434.52,136.44S458,198.18,422,217.3s-38.35-20.81-38.35-20.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M377.7,155.9s20.11,52.82-10.72,69.18c-16.52,8.77-24.76,3-28.84-4.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M338,179.48s14,36.84-7.47,48.25-22.88-12.42-22.88-12.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M865.41,580.74s-23.64,62,10.07,134.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M924.56,602.07s-11.91,66.33,12,113.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M475.59,604s8.71,81.26,0,117.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M512.86,598.5s36.62,84.57,20.94,116.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f9ae9547-d4e3-46ba-a3b2-f7f377aeef97",
    d: "M843.42,343.56s7.19,25.17,37.15,19.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f9ae9547-d4e3-46ba-a3b2-f7f377aeef97",
    d: "M415.2,440.67s-101.61,56.5-162.74-55.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b1ba5eb5-475a-440c-afbd-61b355da7e64",
    d: "M1196.8,494.09l25.4-5.37c4.84-1,7.47-7.53,4.49-11.06l-22.24-26.31a5.92,5.92,0,0,1-1.16-4.78l5.26-33.09c.84-5.28-4.12-8.31-8.44-5.15l-26.33,19.31a5.92,5.92,0,0,1-4.78,1.15l-36-8.29c-4.51-1-9.09,4.28-7.78,9.05l7.61,27.87a7.62,7.62,0,0,1-2.29,7.3l-22.24,20.94c-4,3.74-3.06,10.14,1.54,10.89l40,.94a4.63,4.63,0,0,1,3,1.82l19.12,35.13c2.77,3.74,8.88,1.62,10.39-3.62l9-31.36A7.62,7.62,0,0,1,1196.8,494.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b1ba5eb5-475a-440c-afbd-61b355da7e64",
    d: "M1208.79,96l9.16-7.06c1.74-1.34,1.54-4.46-.34-5.3l-14-6.27a2.63,2.63,0,0,1-1.39-1.69l-4.28-14.29a2.29,2.29,0,0,0-4.38-.44l-6.84,12.84a2.63,2.63,0,0,1-1.69,1.38l-16,3.62c-2,.46-2.82,3.47-1.38,5.14l8.44,9.71a3.39,3.39,0,0,1,.49,3.37l-4.88,12.7c-.87,2.26.73,4.66,2.72,4.07l16.23-7.34a2,2,0,0,1,1.54.15l14.46,10.4c1.84,1,3.88-1.06,3.47-3.45l-2.43-14.33A3.4,3.4,0,0,1,1208.79,96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b1ba5eb5-475a-440c-afbd-61b355da7e64",
    d: "M1286.71,204.12l10-2.66c1.9-.51,2.81-3.15,1.55-4.49l-9.38-10a2.35,2.35,0,0,1-.56-1.87l1.39-13.25a2,2,0,0,0-3.45-1.87l-10.06,8.22a2.38,2.38,0,0,1-1.88.56l-14.46-2.55c-1.82-.31-3.52,1.9-2.91,3.76l3.61,10.91a3,3,0,0,1-.75,3l-8.4,8.79c-1.5,1.56-1,4.09.84,4.29l15.9-.46a1.8,1.8,0,0,1,1.22.66l8.33,13.55c1.18,1.43,3.57.46,4-1.65l2.93-12.65A3,3,0,0,1,1286.71,204.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b1ba5eb5-475a-440c-afbd-61b355da7e64",
    d: "M94.12,456.64l25.39-5.37c4.84-1,7.48-7.53,4.49-11.06L101.77,413.9a5.91,5.91,0,0,1-1.16-4.78L105.86,376c.84-5.28-4.12-8.31-8.43-5.14L71.09,390.2a5.91,5.91,0,0,1-4.78,1.15l-36-8.3c-4.5-1-9.08,4.28-7.78,9.05L30.16,420a7.64,7.64,0,0,1-2.29,7.31L5.63,448.22c-4,3.73-3.06,10.13,1.54,10.89l40,.93a4.61,4.61,0,0,1,3,1.82L69.25,497c2.78,3.74,8.89,1.62,10.39-3.61l9-31.36A7.61,7.61,0,0,1,94.12,456.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b1ba5eb5-475a-440c-afbd-61b355da7e64",
    d: "M113.16,176l10-2.67c1.9-.5,2.82-3.14,1.55-4.48l-9.38-10a2.35,2.35,0,0,1-.56-1.87l1.4-13.26a2,2,0,0,0-3.46-1.86l-10.06,8.22a2.38,2.38,0,0,1-1.88.56l-14.46-2.55c-1.82-.32-3.52,1.89-2.91,3.76L87,162.81a3,3,0,0,1-.75,2.95l-8.4,8.79c-1.5,1.56-1,4.09.84,4.29l15.9-.46a1.8,1.8,0,0,1,1.22.66l8.33,13.55c1.19,1.43,3.57.46,4.06-1.65l2.92-12.65A3,3,0,0,1,113.16,176Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b1ba5eb5-475a-440c-afbd-61b355da7e64",
    d: "M272.78,607.43l-2.85,11.2c-.54,2.14,1.54,4.47,3.54,4l14.88-3.71a2.63,2.63,0,0,1,2.14.48L302.67,628a2.29,2.29,0,0,0,3.72-2.36l-2.53-14.32a2.62,2.62,0,0,1,.48-2.14l10.39-12.74c1.3-1.6.08-4.47-2.09-4.89L300,589.09a3.42,3.42,0,0,1-2.47-2.35l-4-13c-.71-2.31-3.45-3.21-4.65-1.52L280.66,588a2.08,2.08,0,0,1-1.31.83l-17.8.73c-2,.37-2.39,3.23-.6,4.86l10.76,9.78A3.38,3.38,0,0,1,272.78,607.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f54e60f4-bdef-4140-af75-74e178217e8b",
    d: "M260.44,237.61c0-43.24,17-82.82,45.1-113.39l.47-1.81C216.93,147.84,153.72,219.09,153,220c-6.66,7.84-6.11,10.48-6.11,10.48-3.25,8.59-2.63,17.43,2.55,23.69,7.15,8.64,20.79,9.65,33.2,3.41l-19.83,11.51a39.21,39.21,0,0,0-5.1,3h0c-1,.71-2.07,1.48-3.07,2.31-14.67,12.14-18.34,31.91-8.21,44.15s30.24,12.31,44.91.17a40.46,40.46,0,0,0,9.16-10.77l.12.09c-4.24,6.76-5.23,13.55-1.87,17.62,2.55,3.08,7.11,4,12.4,3h0l.2-.05a32.27,32.27,0,0,0,8.45-3c10.7-4.74,29.35-16.12,44.56-41.59l1.38-5.33A162.5,162.5,0,0,1,260.44,237.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e4114198-ea66-45af-a16d-0729c7b506a8",
    d: "M665.3,308a7.93,7.93,0,0,1-.11,6.58L647.8,354.12a133.53,133.53,0,0,1,31.52-16.51c2.1-.7,4.23-1.33,6.36-1.91A128.64,128.64,0,0,1,705,332.08q3.35-.33,6.7-.53a195.63,195.63,0,0,1,33.39,1.05c2.82.55,5.61,1.26,8.37,2.07q3.42,1,6.75,2.22l-.12-12.42a10.2,10.2,0,0,1,5.44-8.68l18.7-10.18A184.3,184.3,0,0,1,776.71,274l-25-7.19a6.17,6.17,0,0,1-3.25-3.37l-12.82-52c-2.32-5.79-10.95-5.12-14.68,1.14l-22.34,37.55a10.19,10.19,0,0,1-8.88,5.1L655,253.58c-6.61-.32-12.24,7.2-9.57,12.79Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "b218f5ac-52ff-40d0-bbb8-9e2478575f0f",
    "data-name": "line art"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M858.58,105.74S837.2,18.29,919.37,5.1c0,0-24.57,54.83,14.17,87.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M965.74,88.24S930,61.47,941.17,39.8c0,0-26.11,2.78-25.83,26.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af0f1cc0-2f96-42f4-982b-636ce73b5e90",
    d: "M1196.8,494.09l25.4-5.37c4.84-1,7.47-7.53,4.49-11.06l-22.24-26.31a5.92,5.92,0,0,1-1.16-4.78l5.26-33.09c.84-5.28-4.12-8.31-8.44-5.15l-26.33,19.31a5.92,5.92,0,0,1-4.78,1.15l-36-8.29c-4.51-1-9.09,4.28-7.78,9.05l7.61,27.87a7.62,7.62,0,0,1-2.29,7.3l-22.24,20.94c-4,3.74-3.06,10.14,1.54,10.89l40,.94a4.63,4.63,0,0,1,3,1.82l19.12,35.13c2.77,3.74,8.88,1.62,10.39-3.62l9-31.36A7.62,7.62,0,0,1,1196.8,494.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af0f1cc0-2f96-42f4-982b-636ce73b5e90",
    d: "M1208.79,96l9.16-7.06c1.74-1.34,1.54-4.46-.34-5.3l-14-6.27a2.63,2.63,0,0,1-1.39-1.69l-4.28-14.29a2.29,2.29,0,0,0-4.38-.44l-6.84,12.84a2.63,2.63,0,0,1-1.69,1.38l-16,3.62c-2,.46-2.82,3.47-1.38,5.14l8.44,9.71a3.39,3.39,0,0,1,.49,3.37l-4.88,12.7c-.87,2.26.73,4.66,2.72,4.07l16.23-7.34a2,2,0,0,1,1.54.15l14.46,10.4c1.84,1,3.88-1.06,3.47-3.45l-2.43-14.33A3.4,3.4,0,0,1,1208.79,96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af0f1cc0-2f96-42f4-982b-636ce73b5e90",
    d: "M1286.71,204.12l10-2.66c1.9-.51,2.81-3.15,1.55-4.49l-9.38-10a2.35,2.35,0,0,1-.56-1.87l1.39-13.25a2,2,0,0,0-3.45-1.87l-10.06,8.22a2.38,2.38,0,0,1-1.88.56l-14.46-2.55c-1.82-.31-3.52,1.9-2.91,3.76l3.61,10.91a3,3,0,0,1-.75,3l-8.4,8.79c-1.5,1.56-1,4.09.84,4.29l15.9-.46a1.8,1.8,0,0,1,1.22.66l8.33,13.55c1.18,1.43,3.57.46,4-1.65l2.93-12.65A3,3,0,0,1,1286.71,204.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af0f1cc0-2f96-42f4-982b-636ce73b5e90",
    d: "M94.12,456.64l25.39-5.37c4.84-1,7.48-7.53,4.49-11.06L101.77,413.9a5.91,5.91,0,0,1-1.16-4.78L105.86,376c.84-5.28-4.12-8.31-8.43-5.14L71.09,390.2a5.91,5.91,0,0,1-4.78,1.15l-36-8.3c-4.5-1-9.08,4.28-7.78,9.05L30.16,420a7.64,7.64,0,0,1-2.29,7.31L5.63,448.22c-4,3.73-3.06,10.13,1.54,10.89l40,.93a4.61,4.61,0,0,1,3,1.82L69.25,497c2.78,3.74,8.89,1.62,10.39-3.61l9-31.36A7.61,7.61,0,0,1,94.12,456.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af0f1cc0-2f96-42f4-982b-636ce73b5e90",
    d: "M113.16,176l10-2.67c1.9-.5,2.82-3.14,1.55-4.48l-9.38-10a2.35,2.35,0,0,1-.56-1.87l1.4-13.26a2,2,0,0,0-3.46-1.86l-10.06,8.22a2.38,2.38,0,0,1-1.88.56l-14.46-2.55c-1.82-.32-3.52,1.89-2.91,3.76L87,162.81a3,3,0,0,1-.75,2.95l-8.4,8.79c-1.5,1.56-1,4.09.84,4.29l15.9-.46a1.8,1.8,0,0,1,1.22.66l8.33,13.55c1.19,1.43,3.57.46,4.06-1.65l2.92-12.65A3,3,0,0,1,113.16,176Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af0f1cc0-2f96-42f4-982b-636ce73b5e90",
    d: "M272.78,607.43l-2.85,11.2c-.54,2.14,1.54,4.47,3.54,4l14.88-3.71a2.63,2.63,0,0,1,2.14.48L302.67,628a2.29,2.29,0,0,0,3.72-2.36l-2.53-14.32a2.62,2.62,0,0,1,.48-2.14l10.39-12.74c1.3-1.6.08-4.47-2.09-4.89L300,589.09a3.42,3.42,0,0,1-2.47-2.35l-4-13c-.71-2.31-3.45-3.21-4.65-1.52L280.66,588a2.08,2.08,0,0,1-1.31.83l-17.8.73c-2,.37-2.39,3.23-.6,4.86l10.76,9.78A3.38,3.38,0,0,1,272.78,607.43Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "bc0b5feb-563d-4fb7-a60b-0f01c78141f8",
    cx: 991.78,
    cy: 238.84,
    r: 12.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "bc0b5feb-563d-4fb7-a60b-0f01c78141f8",
    cx: 595.78,
    cy: 238.84,
    r: 12.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "bc0b5feb-563d-4fb7-a60b-0f01c78141f8",
    cx: 827.09,
    cy: 241.66,
    r: 12.14
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bc0b5feb-563d-4fb7-a60b-0f01c78141f8",
    cx: 719.6,
    cy: 300.76,
    rx: 13.19,
    ry: 11.09,
    transform: "translate(31.39 667.69) rotate(-50.75)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bc0b5feb-563d-4fb7-a60b-0f01c78141f8",
    cx: 1022.29,
    cy: 467.8,
    rx: 13.19,
    ry: 11.09,
    transform: "translate(-52.83 139.12) rotate(-7.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a45bfe8b-37e4-4388-b7c3-2a0f6269eabe",
    d: "M836.86,425.65c10.79-1.06,6.56,13.61,28.55,1.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a45bfe8b-37e4-4388-b7c3-2a0f6269eabe",
    d: "M720,309s7.5,7.6,16.27,22.83"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bc0b5feb-563d-4fb7-a60b-0f01c78141f8",
    cx: 707.66,
    cy: 300.76,
    rx: 11.09,
    ry: 13.19,
    transform: "translate(123.45 800.69) rotate(-63.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bc0b5feb-563d-4fb7-a60b-0f01c78141f8",
    cx: 247.64,
    cy: 377.4,
    rx: 11.09,
    ry: 13.19,
    transform: "translate(-200.54 431.25) rotate(-63.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a45bfe8b-37e4-4388-b7c3-2a0f6269eabe",
    d: "M599.17,447c-22.72,15.65-47.95,24-74.38,17.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a45bfe8b-37e4-4388-b7c3-2a0f6269eabe",
    d: "M702.73,310.69s-3.67,8.08-10.37,20.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f9ae9547-d4e3-46ba-a3b2-f7f377aeef97",
    d: "M543.05,571C528,598.2,505.28,604,475.59,604c-50.23,0-81.42-65-62.74-138.12,9.29-36.35-7.36-55.2-26.35-63.16v0c-73.48-24.25-126-89-126-165.14,0-96,83.68-174,187.45-175.32,104.18-1.3,190.82,76,192.68,172.11,1.29,66.93-38.07,125.48-96.83,156h0c-.63.36-1.25.74-1.86,1.12-16.43,10.32-24.81,28.57-22.26,46.76,3.51,25,15.65,56.86,23.66,75.95q1,2.43,1.86,4.91S556.72,546.12,543.05,571Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bc0b5feb-563d-4fb7-a60b-0f01c78141f8",
    cx: 938.88,
    cy: 479.12,
    rx: 5.44,
    ry: 4.57,
    transform: "translate(-61.65 810.76) rotate(-45.37)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bc0b5feb-563d-4fb7-a60b-0f01c78141f8",
    cx: 938.88,
    cy: 474.09,
    rx: 4.57,
    ry: 5.44,
    transform: "translate(217.13 1239.16) rotate(-73.46)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "bc0b5feb-563d-4fb7-a60b-0f01c78141f8",
    cx: 977.36,
    cy: 393.22,
    r: 4.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "bc0b5feb-563d-4fb7-a60b-0f01c78141f8",
    cx: 928.58,
    cy: 412.05,
    r: 4.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M977.53,319.29a62.84,62.84,0,0,1,21.72,15c1.18,1.22,2.3,2.49,3.38,3.8s2.42,2.69,3.56,4.11a61.71,61.71,0,0,1,10.89,56.47,40.4,40.4,0,0,1-7.46,13.58c-2.91,3.57-6.09,9.36-2.33,14.73.39.56.69,1,1.27,1.94l3.79,6.8c9.7,18.91,23.77,59.37-21.67,62.06C969.61,499,964.75,473,964.1,458.24a50.09,50.09,0,0,0-1.38-9.68h0a10.18,10.18,0,0,0-4.84-6.49l-.4-.22a13.19,13.19,0,0,0-6.08-1.54q-2.86,0-5.7-.12a30.32,30.32,0,0,1-9.5-1.92l-.05,0a61.56,61.56,0,0,1-39-49.46,62.92,62.92,0,0,1-.53-8.62c0-1.42.07-2.83.15-4.25.78-17.16,5.3-35.57,19.54-46.24"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    cx: 944.31,
    cy: 309.89,
    r: 7.76
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M911,304.35a4.25,4.25,0,0,1,5.77-3.62l19.92,7.69a7.74,7.74,0,0,1,13-4.1l15.95-15a3.68,3.68,0,0,1,5.93,1.29c6.1,14.89,6.51,24.51,5.83,29.87a4.24,4.24,0,0,1-5.91,3.37l-21.06-9.2a7.73,7.73,0,0,1-8.92,2.47L924.1,335a3.68,3.68,0,0,1-6-1C911.39,319.33,910.56,309.73,911,304.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M946.51,302.31c-3-7.17-7.37-14-15.26-17.52a78.07,78.07,0,0,1,7.57,19.62"
  })), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M856.16,93.83a184.75,184.75,0,0,0,5,309.54h0s12.22,9.21,6.29,35.91C861.47,472.66,818.45,567.6,906.71,598c68.72,23.67,74.94-55.62,75.73-101.34-14.15-5.05-17.79-25.86-18.34-38.43a50.09,50.09,0,0,0-1.38-9.68,10.18,10.18,0,0,0-4.84-6.49l-.4-.22a13.19,13.19,0,0,0-6.08-1.54q-2.86,0-5.7-.12a30.32,30.32,0,0,1-9.5-1.92l-.05,0a61.56,61.56,0,0,1-39-49.46,62.92,62.92,0,0,1-.53-8.62c0-1.42.07-2.83.15-4.25.78-17.16,5.3-35.57,19.54-46.24h0c-5-12.23-5.67-20.49-5.28-25.33a4.25,4.25,0,0,1,5.77-3.62l19.92,7.7a7.89,7.89,0,0,1,2.14-4h0a78.07,78.07,0,0,0-7.57-19.62c7.89,3.49,12.21,10.35,15.26,17.52l-.3.08a7.65,7.65,0,0,1,3.48,1.93l15.95-15a3.68,3.68,0,0,1,5.93,1.29c5.67,13.85,6.42,23.13,5.95,28.68h0a62.84,62.84,0,0,1,21.72,15c1.18,1.22,2.3,2.49,3.38,3.8s2.42,2.69,3.56,4.11a61.71,61.71,0,0,1,10.89,56.47,40.4,40.4,0,0,1-7.46,13.58c-2.66,3.28-5.54,8.41-3.11,13.38A184.75,184.75,0,0,0,1144.14,247c0-102-82.69-184.71-184.7-184.71q-7.61,0-15.05.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a45bfe8b-37e4-4388-b7c3-2a0f6269eabe",
    d: "M995.86,497.82s4.08,16.58-5.76,39.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a45bfe8b-37e4-4388-b7c3-2a0f6269eabe",
    d: "M1011.09,493s4.08,16.58-5.76,39.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a45bfe8b-37e4-4388-b7c3-2a0f6269eabe",
    d: "M998.44,439.26s-2.17,25.38-58,34.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a45bfe8b-37e4-4388-b7c3-2a0f6269eabe",
    d: "M962.76,450.16S959.43,465.38,939.2,478"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bc0b5feb-563d-4fb7-a60b-0f01c78141f8",
    cx: 808.27,
    cy: 605.86,
    rx: 6.72,
    ry: 7.99,
    transform: "translate(-199.21 679) rotate(-41.01)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bc0b5feb-563d-4fb7-a60b-0f01c78141f8",
    cx: 627.22,
    cy: 558.44,
    rx: 6.72,
    ry: 7.99,
    transform: "translate(-212.52 548.56) rotate(-41.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M662.94,554.82a119.84,119.84,0,0,1-60.2-79.65c-.58-2.66-1.07-5.36-1.42-8.14a151.2,151.2,0,0,1,9.45-67c1.12-2.5,2.37-5,3.72-7.48a120.79,120.79,0,0,1,15-21.48q2.14-2.46,4.43-4.8c12.37-13.12,28.9-22.47,45.45-28.61,2.1-.7,4.23-1.33,6.36-1.91A128.64,128.64,0,0,1,705,332.08q3.35-.33,6.7-.53a195.63,195.63,0,0,1,33.39,1.05c2.82.55,5.61,1.26,8.37,2.07,2.47.73,4.92,1.54,7.33,2.43s4.78,1.84,7.11,2.87a114.75,114.75,0,0,1,33.73,22.55c1.65,1.58,3.26,3.2,4.83,4.88,14.41,16.6,26.63,36,30.4,58.25.52,2.56.95,5.16,1.3,7.78a120.81,120.81,0,0,1,1.07,16,119.22,119.22,0,0,1-9,45.52c-1,2.34-2,4.64-3.1,6.9C814.41,523.42,796.44,541.39,776,555c-2.21,1.19-4.47,2.3-6.76,3.35h0c-6,3.15-9.32,12.34-8.79,15.33,1.2,6.79-2,29.62-3.84,36.27-19.4,69.29-61,61.86-77.86,61.23-22.53-.83-40.37-18.28-40.82-40.82-.59-29.65,20-54.06,30.38-61.24C675.15,564.34,668.37,558.36,662.94,554.82Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a11db4fb-67b7-4bde-be06-572dc03d7024",
    cx: 766.95,
    cy: 650.01,
    rx: 43.79,
    ry: 71.92
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bc0b5feb-563d-4fb7-a60b-0f01c78141f8",
    cx: 766.95,
    cy: 650.01,
    rx: 13.02,
    ry: 21.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa3c9cd1-9f7a-4e7d-a371-0f23f1588309",
    d: "M672.61,670.48c-7.53,21.76-21.77,36.44-38.1,36.44-24.19,0-43.79-32.2-43.79-71.92s19.6-71.92,43.79-71.92c10.09,0,18.1,4,25.51,13.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bc0b5feb-563d-4fb7-a60b-0f01c78141f8",
    d: "M639.45,615.21a8.75,8.75,0,0,0-4.94-1.6c-7.19,0-13,9.58-13,21.39s5.83,21.39,13,21.39c3.51,0,6.69-2.29,9-6A41.38,41.38,0,0,1,638,630.31,65.09,65.09,0,0,1,639.45,615.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M662.63,650S597.84,665.67,538,605.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M709.84,648.16S645,663.82,585.23,604"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M761.66,567.72s105.58-49.85,43.07,45.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M671,565.91s-75.28-53.44-41.1-2.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M671,505.46c0,30.38,52.18,30.38,52.18,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M627.22,451.34q21.87-14.23,43.76-5.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M763.36,451.34q-21.89-14.23-43.76-5.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M1006.51,425.62s139.67,6.95,15.78,44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M500.88,101.06s38.73,61.81-6.82,89.45-50.64-16.74-50.64-16.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M434.52,136.44S458,198.18,422,217.3s-38.35-20.81-38.35-20.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M377.7,155.9s20.11,52.82-10.72,69.18c-16.52,8.77-24.76,3-28.84-4.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M338,179.48s14,36.84-7.47,48.25-22.88-12.42-22.88-12.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M264.3,284c-15.21,25.47-33.86,36.85-44.56,41.59a32.27,32.27,0,0,1-8.45,3l-.2.05h0c-5.29,1-9.85.08-12.4-3-3.36-4.07-2.37-10.86,1.87-17.62l-.12-.09a40.46,40.46,0,0,1-9.16,10.77c-14.67,12.14-34.78,12.07-44.91-.17s-6.46-32,8.21-44.15c1-.83,2-1.6,3.07-2.31h0a39.21,39.21,0,0,1,5.1-3L182.6,257.6c-12.41,6.24-26,5.23-33.2-3.41-5.18-6.26-5.8-15.1-2.55-23.69h0S146.3,227.86,153,220c.76-.93,64-72.18,153-97.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M865.41,580.74s-23.64,62,10.07,134.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M924.56,602.07s-11.91,66.33,12,113.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M475.59,604s8.71,81.26,0,117.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbe4f893-329d-46d5-a076-961d9f041937",
    d: "M512.86,598.5s36.62,84.57,20.94,116.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f9ae9547-d4e3-46ba-a3b2-f7f377aeef97",
    d: "M843.42,343.56s7.19,25.17,37.15,19.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f9ae9547-d4e3-46ba-a3b2-f7f377aeef97",
    d: "M415.2,440.67s-101.61,56.5-162.74-55.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fadfdf82-06e2-42f7-9290-8e74cda83a61",
    d: "M665.3,308a7.93,7.93,0,0,1-.11,6.58L647.8,354.12a133.53,133.53,0,0,1,31.52-16.51c2.1-.7,4.23-1.33,6.36-1.91A128.64,128.64,0,0,1,705,332.08q3.35-.33,6.7-.53a195.63,195.63,0,0,1,33.39,1.05c2.82.55,5.61,1.26,8.37,2.07q3.42,1,6.75,2.22l-.12-12.42a10.2,10.2,0,0,1,5.44-8.68l18.7-10.18A184.3,184.3,0,0,1,776.71,274l-25-7.19a6.17,6.17,0,0,1-3.25-3.37l-12.82-52c-2.32-5.79-10.95-5.12-14.68,1.14l-22.34,37.55a10.19,10.19,0,0,1-8.88,5.1L655,253.58c-6.61-.32-12.24,7.2-9.57,12.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a54fbd87-bec4-411d-87ab-5a8e2b316ee1",
    d: "M774.73,247a183.83,183.83,0,0,1,33.35-105.87L782.6,37.81c-6.58-16.4-31-14.49-41.6,3.25L677.69,147.44c-5.44,9.13-15.53,14.93-25.17,14.47l-31.47-1.52a162.72,162.72,0,0,1,19.52,74c1.16,60.23-30.61,113.68-79.81,146l-29,65.89c-8.17,18.58,7.11,34.46,26,27l43.06-17A148.86,148.86,0,0,1,610.77,400c1.12-2.5,2.37-5,3.72-7.48a120.79,120.79,0,0,1,15-21.48q2.14-2.46,4.43-4.8c12.37-13.12,28.9-22.47,45.45-28.61,2.1-.7,4.23-1.33,6.36-1.91A128.64,128.64,0,0,1,705,332.08q3.35-.33,6.7-.53a195.63,195.63,0,0,1,33.39,1.05c2.82.55,5.61,1.26,8.37,2.07,2.47.73,4.92,1.54,7.33,2.43s4.78,1.84,7.11,2.87a114.75,114.75,0,0,1,33.73,22.55c1.65,1.58,3.26,3.2,4.83,4.88,14.41,16.6,26.63,36,30.4,58.25.52,2.56.95,5.16,1.3,7.78a120.81,120.81,0,0,1,1.07,16,119.22,119.22,0,0,1-9,45.52l0,.05c11.92-2.67,22.86-14.11,22.72-27.38l-.7-70.22A184.45,184.45,0,0,1,774.73,247Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamily);
export default __webpack_public_path__ + "static/media/family.a7dfd88e0f3987414120468a96b165f0.svg";
export { ForwardRef as ReactComponent };